/**
 * Карточка элемента адресной книги для hover-превью (зеркало backend PersonCardDto):
 * для людей — ФИО, должность, контакты; для групп — тип и участники.
 */
/** Участник группы для hover-превью: имя + ключ адресной книги (для своей hover-карточки). */
export interface IPersonCardMember {
    name: string;
    key: string;
}

export interface IPersonCard {
    key: string;
    displayName: string;
    /** user / workgroup / accessgroup / department / role / maillist / group */
    itemType?: string;
    /** участники (для групп; первые несколько) — имя + ключ для hover-карточки */
    members?: IPersonCardMember[];
    /** полное число участников (для групп) */
    membersTotal?: number;
    post?: string;
    department?: string;
    organization?: string;
    email?: string;
    phone?: string;
    room?: string;
    isDismissed: boolean;
    /** заблокирован (PersonProperties.Locked); в карточке показывается как «В отпуске» */
    isLocked?: boolean;
    /** учётная запись деактивирована / не активирована (PersonProperties.Deactivated) */
    isDeactivated?: boolean;
    /** интеграционная УЗ (обмен между системами, без UI) — метка-иконка у имени */
    isIntegration?: boolean;
    /** роботизированная УЗ (RPA) — метка-иконка у имени */
    isUIAutomation?: boolean;
    /** есть ли у элемента фото (само фото — GET addressBook/{key}/avatar) */
    hasImage?: boolean;
    /** версия фото (photoVersion) для версионированного ?v= URL */
    photoVersion?: string;
    /** руководитель группы (рабочая группа/подразделение) — ключ, имя и должность */
    chiefKey?: string;
    chiefName?: string;
    chiefPost?: string;
    /** постоянный заместитель (уполномоченный) сотрудника */
    assistantKey?: string;
    assistantName?: string;
    /** временный заместитель (ВРИО) сотрудника + срок действия (ISO-строки дат) */
    dummyKey?: string;
    dummyName?: string;
    dummyStartDate?: string;
    dummyEndDate?: string;
}

/** Страница участников группы (эндпоинт GET addressbook/group/{key}/members). */
export interface IGroupMembersPage {
    data: IPersonCardMember[];
    totalCount: number;
}

/** Элемент адресной книги — сотрудник (у групп тип свой, см. {@link abookItemTypeLabel}). */
export const isAbookPerson = (item: { type?: string }) => !item.type || item.type === 'user';

/** Человекочитаемая подпись типа элемента адресной книги; для людей не показывается. */
export function abookItemTypeLabel(itemType?: string): string | undefined {
    switch (itemType) {
        case 'workgroup':
            return 'рабочая группа';
        case 'accessgroup':
            return 'группа доступа';
        case 'department':
            return 'подразделение';
        case 'role':
            return 'роль';
        case 'maillist':
            return 'список рассылки';
        case 'group':
            return 'группа';
        default:
            return undefined;
    }
}
